import { translateFun } from "../Translation";
import ListAccordianASCO from './ListAccordianASCO';

const ListAccordian = (props) => {
  const {
    Title,
    ListData,
    Count,
    IsAddAction = false,
    AccQtyIncrementClick,
    AccQtyDecrClick,
    AccAddBtnClick,
    intialPartsarray,
    AccordionKey,
    IsDeleteItemAction = false,
    ItemDeleteClick,
    IsExpanded,
    setExpanded,
    productForImageModal,
    setProductForImageModal,
    DisplayResultCount,
    imageModalLoader, //loader for image modal
    setImageModalLoader,
    param,
    MinQuantity = null,
    handleOpen,
    Accordion,
    AccordionSummary,
    Typography,
    List,
    ListItem,
    ListItemAvatar,
    Avatar,
    ListItemText,
    Button,
    Tooltip,
    ExpandMoreIcon,
    AddIcon,
    CancelIcon,
    RemoveCircleIcon,
    AddCircleIcon,
    InfoRoundedIcon,
    ArrowRightIcon,
    maxCapacity,
    totalSumNumber
  } = props;

  const MiAStyle = {
    position: 'absolute',
    zIndex: 2,
    top: 0,
    left: 13,
    height: 'auto'
  };

  return (
    <Accordion expanded={IsExpanded} key={AccordionKey}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls="panel1a-content"
        id="panel1a-header"
        className="accordion-summary"
        onClick={() => setExpanded(!IsExpanded)}
      >
        <Typography className="accordion-header-title">
          {Title}
          <span className="badge">{Count}</span>
          {DisplayResultCount ? (
            <span className="result">{`(${ListData.length}) ${translateFun("Results")}`}</span>
          ) : null}
        </Typography>
      </AccordionSummary>

      {ListData.map((data, aIndex) => (
        <List
          sx={{
            width: "100%",
            maxWidth: 360,
            bgcolor: "background.paper",
            cursor: "pointer",
          }}
          key={aIndex}
          style={{ cursor: "unset" }}
          className="part_acs_ul"
        >
          <ListItem key={"ListItem" + aIndex}>
            <ListItemAvatar
              className={
                data?.Catalog === productForImageModal?.Catalog
                  ? "catalog-code_active Avatar_image "
                  : "Avatar_image"
              }
            >
              {(data?.Description?.includes("TAA") || data?.Description?.includes("BAA") || data?.Description?.includes("BABA")) 
              && (
                      <img
                      src={process.env.PUBLIC_URL + "/asset/images/MiA_Logo.png"}
                      alt="MiA" height="40%" width="6%" title="MiA" 
                      style={MiAStyle}
                  />
              )}
              <Avatar
                variant="square"
                alt="Remy Sharp"
                src={
                  data?.Image_Url
                    ? data?.Image_Url
                    : process.env.PUBLIC_URL + "/asset/images/no Image_av.png"
                }
              />
              <div className={"catalog_div"}>
                <div className="code-info">
                  <div className="description_div">
                    <ListItemText
                      className={"detailsButton catelog-code"}
                      primary={data["Catalog"]}
                      // onClick={() => {

                      // }}
                      onClick={() => {
                        if (setProductForImageModal) {
                          setProductForImageModal({});
                          setImageModalLoader(true);
                          // setproductNo(data);
                          setProductForImageModal(data);
                          if (param == "qacomponent") {
                            handleOpen();
                          } else {
                            // setImageUrl("");
                          }
                          if (data.Thumbnail_Image_Url) {
                            // setImageUrl(
                            //   data?.Thumbnail_Image_Url?.split("File_Ext")[0] +
                            //   "File_Ext=.JPG"
                            // );
                          }
                        }
                      }}
                    ></ListItemText>
                    {/* {
                      param == "qacomponent" ?<button className="detailsButton" onClick={() => {
                        if (setProductForImageModal) {
                          setProductForImageModal({});
                          setImageModalLoader(true);
                          // setproductNo(data);
                          setProductForImageModal(data);
                          if (param == "qacomponent") {
                            handleOpen();
                          } else {
                            // setImageUrl("");
                          }
                          if (data.Thumbnail_Image_Url) {
                            // setImageUrl(
                            //   data?.Thumbnail_Image_Url?.split("File_Ext")[0] +
                            //   "File_Ext=.JPG"
                            // );
                          }
                        }
                      }}>
                       <ArrowRightIcon />
                    </button> : <></>
                    }
                      */}
                    {!data?.localStockCode?.startsWith("Stock") && (
                      <Tooltip title="May not be in stock, please check">
                        <InfoRoundedIcon />
                      </Tooltip>
                    )}

                    {AccordionKey === "PartsSection" ? (
                      <label className="qut-info">{`x${data.partsQuantity}`}</label>
                    ) : (
                      ""
                    )}
                  </div>
                </div>

                <Tooltip id="catelog-detail-tooltip">
                  <ListItemText
                    className="catelog-detail"
                    primary={data.Description}
                  />
                </Tooltip>
              </div>
            </ListItemAvatar>
            <div className="content-info">
              {IsAddAction == true ? (
                <div className="add-btn" key={aIndex}>
                  {!intialPartsarray[aIndex] ? (
                    <Button
                      variant="contained"
                      onClick={() => AccAddBtnClick({ aIndex, data })}
                    >
                      <AddIcon /> {translateFun("Add")}
                    </Button>
                  ) : (
                    <span className="quatity-btns">
                      <Button
                        variant="contained"
                        onClick={() => AccQtyDecrClick({ aIndex, data })}
                        disabled={
                          MinQuantity !== null &&
                            intialPartsarray[aIndex]?.quantity === MinQuantity
                            ? true
                            : false
                        }
                        {...(MinQuantity !== null &&
                          intialPartsarray[aIndex]?.quantity === MinQuantity
                          ? { style: { color: "lightgray" } }
                          : {})}
                      >
                        <RemoveCircleIcon />
                      </Button>
                      <h4>{intialPartsarray[aIndex]?.quantity}</h4>
                      <Button
                        disabled={(totalSumNumber && maxCapacity) ? totalSumNumber < maxCapacity ? false : true : false}
                        variant="contained"
                        onClick={() => AccQtyIncrementClick({ aIndex, data })}
                      >
                        <AddCircleIcon />
                      </Button>
                    </span>
                  )}
                </div>
              ) : (
                ""
              )}
            </div>
          </ListItem>
          {IsDeleteItemAction == true ? (
            <div className="delete-cart-item-btn">
              <Button
                variant="contained"
                onClick={() => {
                  ItemDeleteClick(aIndex);
                }}
              >
                <Tooltip title={translateFun("RemovedItems")}>
                  <CancelIcon />
                </Tooltip>
              </Button>
            </div>
          ) : (
            ""
          )}
        </List>
      ))}
    </Accordion>
  );
};

export default function PartsAccList(props) {
  const {
    param,
    React,
    AppContext,
    ImageModal,
    PublishMessageAddToProject,
    PublishMessageClose,
    lang, PublishMessageSolution,
    PublishMessageAddToProjectEZ3,
    PublishMessageSolutionConsoleEvent,
    PartId
  } = props;

  const productNumber = PartId?.split(".")[1]
  
  const { useContext, useState, useEffect } = React;
  let {
    Parts,
    Accessories,
    BreakerQueList,
    MainBreakersList,
    BranchBreakersList,
    AccessoriesCartCount,
    AccCartQtyInfoArr,
    updateAccCartCount,
    updateAccCartQtyInfoArr,
    BranchBreakerCartCnt,
    BranchBrkCartInfoArr,
    updateBranchBrkCartCount,
    updateBranchBrkCartInfoArr,
    updateMainBreakerList,
    updateBranchBreakerList,
    updateBreakerValObj,
    updateAccessoriesCartInfo,
    AccessoriesCartInfoArr,
    PartsListExpanded,
    setPartsListExpanded,
    AccListExpanded,
    setAccListExpanded,
    MainBrkListExpanded,
    setMainBrkListExpanded,
    BranchBrkListExpanded,
    setBranchBrkListExpanded,
    productForImageModal,
    setProductForImageModal,
    setImageModalLoader,
    ExtraAccCartInfoArr,
    setExtraAccCartInfoArr,
    ExtraAccCartCount,
    setExtraAccCartCount,
    ExtraAccListExpanded,
    setExtraAccListExpanded,
    ExtraAccCatCartList,
    setExtraAccCatCartList,
    ExtraAccList,
    setExtraAccList,
    Accordion,
    AccordionSummary,
    Typography,
    List,
    ListItem,
    ListItemAvatar,
    Avatar,
    ListItemText,
    Tooltip,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    ExpandMore: ExpandMoreIcon,
    Add: AddIcon,
    AddCircle: AddCircleIcon,
    RemoveCircle: RemoveCircleIcon,
    DeleteOutlined: CancelIcon,
    InfoRounded: InfoRoundedIcon,
    Modal,
    KeyboardArrowRight: ArrowRightIcon,
    maxCapacity,
    accCritArr = [],
    disbAccArr,
    setDisbAccArr,
    mandSelAccArr,
    setMandSelAccArr
  } = useContext(AppContext);

  const [ResponseJSON, setResponseJSON] = useState(null);
  const [ResponseModel, setResponseModel] = useState(false);
  
  const [openImageModal, setOpenImageModal] = useState(false);
  const handleOpen = () => setOpenImageModal(true);
  const handleClose = () => setOpenImageModal(false);

  let accMutualExlArr = accCritArr?.Mutual_exclusion?.[0]?accCritArr?.Mutual_exclusion:[];
  let accMandSelArr   = accCritArr?.Mandatory_selection?.[0]?accCritArr?.Mandatory_selection:[];

  const AccQtyIncrementClick = ({ aIndex, data }) => {
    if (!AccCartQtyInfoArr[aIndex]) {
      AccCartQtyInfoArr[aIndex] = { quantity: 1, Catalog: data.Catalog };
    } else {
      let newAccCount = AccessoriesCartCount + 1;
      updateAccCartCount(newAccCount);
      AccCartQtyInfoArr[aIndex] = {
        ...AccCartQtyInfoArr[aIndex],
        quantity: AccCartQtyInfoArr[aIndex].quantity + 1,
      };
    }

    if (data) {
      AccessoriesCartInfoArr.forEach((a, index) => {
        if (AccessoriesCartInfoArr[index].Catalog === data.Catalog) {
          AccessoriesCartInfoArr[index].quantity =
            AccessoriesCartInfoArr[index].quantity + 1;
          updateAccessoriesCartInfo([...AccessoriesCartInfoArr]);
        }
      });
    }
    updateAccCartQtyInfoArr([...AccCartQtyInfoArr]);

    let partsAccData = {};
    let partsData = [];
    let accData = [];
    Parts.forEach(element => {
      partsData.push({ quantity: 1, catalog: element.Catalog })
    });
    Accessories.forEach(element => {
      accData.push({ quantity: 0, catalog: element.Catalog })
    });
    accData.forEach(element => {
      const findEle = AccCartQtyInfoArr.filter(obj => {
        if (obj)
          return obj.Catalog === element.catalog
      });
      if (findEle.length > 0) {
        element.quantity = findEle[0].quantity;
      }
    });
    partsAccData["Parts"] = partsData;
    partsAccData["Accessories"] = accData;
    PublishMessageSolutionConsoleEvent(partsAccData);
  };

  const AccQtyDecrClick = ({ aIndex, data }) => {
    if (AccCartQtyInfoArr[aIndex].quantity <= 1) {
      delete AccCartQtyInfoArr[aIndex];

      if(accMutualExlArr.length > 0)
      {
        const newDisbAccArr = {...disbAccArr};
        if (newDisbAccArr.hasOwnProperty(data.Catalog)) {
          delete newDisbAccArr[data.Catalog];
          setDisbAccArr(newDisbAccArr);
        }
      }
      if(accMandSelArr.length > 0)
      {
        const newMandSelAccArr = {...mandSelAccArr};
        if (newMandSelAccArr.hasOwnProperty(data.Catalog)) {
          delete newMandSelAccArr[data.Catalog];
          setMandSelAccArr(newMandSelAccArr);
        }
      }

    } else {
      AccCartQtyInfoArr[aIndex] = {
        ...AccCartQtyInfoArr[aIndex],
        quantity: AccCartQtyInfoArr[aIndex].quantity - 1,
      };
    }

    AccessoriesCartInfoArr.forEach((a, index) => {
      if (AccessoriesCartInfoArr[index].Catalog === data.Catalog) {
        if (AccessoriesCartInfoArr[index].quantity <= 1) {
          let NewArray = AccessoriesCartInfoArr.filter(
            (d) => d.Catalog !== data.Catalog
          );
          updateAccessoriesCartInfo([...NewArray]);
        } else {
          AccessoriesCartInfoArr[index].quantity =
            AccessoriesCartInfoArr[index].quantity - 1;
          updateAccessoriesCartInfo([...AccessoriesCartInfoArr]);
        }
      }
    });

    updateAccCartCount(AccessoriesCartCount - 1);
    updateAccCartQtyInfoArr([...AccCartQtyInfoArr]);


    let partsAccData = {};
    let partsData = [];
    let accData = [];
    Parts.forEach(element => {
      partsData.push({ quantity: 1, catalog: element.Catalog })
    });
    Accessories.forEach(element => {
      accData.push({ quantity: 0, catalog: element.Catalog })
    });
    accData.forEach(element => {
      const findEle = AccCartQtyInfoArr.filter(obj => {
        if (obj)
          return obj.Catalog === element.catalog
      });
      if (findEle.length > 0) {
        element.quantity = findEle[0].quantity;
      }
    });
    partsAccData["Parts"] = partsData;
    partsAccData["Accessories"] = accData;
    PublishMessageSolutionConsoleEvent(partsAccData);
  };

  const AccAddMandatory = (mandAccArr, mandAccListIndexArr) => {
    updateAccCartCount(mandAccListIndexArr.length);
    const accCartInfoArr = [];
    mandAccArr.forEach((eachAccList, mandAccKey) => {
      AccCartQtyInfoArr[mandAccKey] = { quantity: 1, Catalog: eachAccList.Catalog };
      eachAccList.quantity = 1;
      accCartInfoArr.push(eachAccList);
    });
    updateAccCartQtyInfoArr([...AccCartQtyInfoArr]);
    updateAccessoriesCartInfo([...accCartInfoArr]);
  };

  const ASCOAccAddBtnClick = ({ aIndex, data }) => {
    let accToAdd  = 1;
    AccCartQtyInfoArr[aIndex] = { quantity: 1, Catalog: data.Catalog };
    data.quantity = 1;
    let tempAccCartInfoArr  = [...AccessoriesCartInfoArr, data];
    
    if(accMandSelArr.length > 0)
    {
      let accMandSelList = findMandSelAcc(accMandSelArr, data.Catalog);
      
      if(accMandSelList)
      {
        let tempMandSelAccArr  = {};
        tempMandSelAccArr[data.Catalog]  = accMandSelList;
        setMandSelAccArr(prevMandSelAcc => ({
          ...prevMandSelAcc,
          ...tempMandSelAccArr
        }));

        if(AccCartQtyInfoArr.length > 0)
        {
          accMandSelList.forEach((eachMandSelAcc) => {
            let isAccAlreadyAdded = AccCartQtyInfoArr.some(item => item?.Catalog === eachMandSelAcc);
            if(!isAccAlreadyAdded)
            {
              let accIndexNo  = Accessories.findIndex(item => item.Catalog === eachMandSelAcc);
              AccCartQtyInfoArr[accIndexNo] = { quantity: 1, Catalog: eachMandSelAcc };
              accToAdd++;

              let accDetailsArr = {...Accessories[accIndexNo]};
              accDetailsArr.quantity = 1;
              tempAccCartInfoArr.push(accDetailsArr);
            }
          });
        }
      }
    }

    updateAccCartCount(AccessoriesCartCount + accToAdd);
    updateAccCartQtyInfoArr([...AccCartQtyInfoArr]);
    
    let partsAccData = {};
    let partsData = [];
    let accData = [];
    Parts.forEach(element => {
      partsData.push({ quantity: 1, catalog: element.Catalog })
    });
    Accessories.forEach(element => {
      accData.push({ quantity: 0, catalog: element.Catalog })
    });
    accData.forEach(element => {
      const findEle = AccCartQtyInfoArr.filter(obj => {
        if (obj)
          return obj.Catalog === element.catalog
      });
      if (findEle.length > 0) {
        element.quantity = findEle[0].quantity;
      }
    });
    partsAccData["Parts"] = partsData;
    partsAccData["Accessories"] = accData;
    PublishMessageSolutionConsoleEvent(partsAccData);

    updateAccessoriesCartInfo([...tempAccCartInfoArr]);

    if(accMutualExlArr.length > 0)
    {
      let accMutualExlList = findMutualAcc(accMutualExlArr, data.Catalog)
      if(accMutualExlList)
      {
        let tempdisbAccArr  = {};
        tempdisbAccArr[data.Catalog]  = accMutualExlList;
        setDisbAccArr(prevAccessories => ({
          ...prevAccessories,
          ...tempdisbAccArr
        }));
      }
    }
  };

  const AccAddBtnClick = ({ aIndex, data }) => {
    updateAccCartCount(AccessoriesCartCount + 1);
    AccCartQtyInfoArr[aIndex] = { quantity: 1, Catalog: data.Catalog };
    updateAccCartQtyInfoArr([...AccCartQtyInfoArr]);
    
    let partsAccData = {};
    let partsData = [];
    let accData = [];
    Parts.forEach(element => {
      partsData.push({ quantity: 1, catalog: element.Catalog })
    });
    Accessories.forEach(element => {
      accData.push({ quantity: 0, catalog: element.Catalog })
    });
    accData.forEach(element => {
      const findEle = AccCartQtyInfoArr.filter(obj => {
        if (obj)
          return obj.Catalog === element.catalog
      });
      if (findEle.length > 0) {
        element.quantity = findEle[0].quantity;
      }
    });
    partsAccData["Parts"] = partsData;
    partsAccData["Accessories"] = accData;
    PublishMessageSolutionConsoleEvent(partsAccData);

    if (data) {
      data.quantity = 1;
      updateAccessoriesCartInfo([...AccessoriesCartInfoArr, data]);
    }
  };

  const findMutualAcc = (array, target) => {
    for (let item of array) {
      const mutAccArr = item.split('|');
      if (mutAccArr.includes(target)) {
        return mutAccArr.filter((Obj) => Obj != target);
      }
    }
    return null;
  };

  const findMandSelAcc = (array, target) => {
    for (let item of array) {
      const manAccArr = item.split('|');
      if (manAccArr.includes(target)) {
        if(manAccArr[0] == target)
          return manAccArr.filter((Obj) => Obj != target);
        else
          return null;
      }
    }
    return null;
  };

  const BranchBrkQtyIncrementClick = ({ aIndex }) => {
    if (!BranchBrkCartInfoArr[aIndex]) {
      BranchBrkCartInfoArr[aIndex] = { quantity: 1 };
    } else {
      let newAccCount = BranchBreakerCartCnt + 1;
      updateBranchBrkCartCount(newAccCount);
      BranchBrkCartInfoArr[aIndex] = {
        ...BranchBrkCartInfoArr[aIndex],
        quantity: BranchBrkCartInfoArr[aIndex].quantity + 1,
      };
    }
    updateBranchBrkCartInfoArr([...BranchBrkCartInfoArr]);
  };

  const BranchBrkQtyDecrClick = ({ aIndex }) => {
    if (BranchBrkCartInfoArr[aIndex].quantity <= 1) {
      delete BranchBrkCartInfoArr[aIndex];
    } else {
      BranchBrkCartInfoArr[aIndex] = {
        quantity: BranchBrkCartInfoArr[aIndex].quantity - 1,
      };
    }

    updateBranchBrkCartCount(BranchBreakerCartCnt - 1);
    updateBranchBrkCartInfoArr([...BranchBrkCartInfoArr]);
  };

  const BranchBrkAddBtnClick = ({ aIndex }) => {
    updateBranchBrkCartCount(BranchBreakerCartCnt + 1);
    BranchBrkCartInfoArr[aIndex] = { quantity: 1 };
    updateBranchBrkCartInfoArr([...BranchBrkCartInfoArr]);
  };

  const MainBreakerDeleteClick = (index) => {
    MainBreakersList.splice(index, 1);
    updateMainBreakerList([...MainBreakersList]);
    if (!MainBreakersList.length) updateBreakerValObj({});
  };
  const BranchBreakerDeleteClick = (index) => {
    BranchBreakersList.splice(index, 1);
    updateBranchBreakerList([...BranchBreakersList]);

    BranchBrkCartInfoArr.splice(index, 1);
    let newCount = BranchBrkCartInfoArr.reduce((c, i) => c + i.quantity, 0);
    updateBranchBrkCartCount(newCount);
    updateBranchBrkCartInfoArr([...BranchBrkCartInfoArr]);
  };

  const AddToCartClick = () => {
    let data = [
      ...Parts,
      ...AccessoriesCartInfoArr,
      ...MainBreakersList,
      ...BranchBrkCartInfoArr,
      ...ExtraAccList,
    ];
    let getdata = [];
    if(productNumber == 'ASCO1')
    {
      let tempFinalObj          = {};
      tempFinalObj.catalogNo    = data.map((item) => item.Catalog.replace('Accessory-', '')).join(',');
      tempFinalObj.designation  = "final-part";
      tempFinalObj.quantity     = 1;
      tempFinalObj.gtin         = "";
      getdata.push(tempFinalObj);
    }
    else
    {
      data.forEach((element) => {
        const dataObject = {};
        dataObject.catalogNo = element.Catalog;
        dataObject.designation = "final-part";
        dataObject.description = element.Description;
        dataObject.pictureUrl = element.Image_Url;
        dataObject.dataSheetUrl = element.Datasheet_Url;
        dataObject.quantity = element.partsQuantity ? parseInt(element.partsQuantity) : element.quantity ? element.quantity : 1;
        getdata.push(dataObject);
      });
    }

    PublishMessageAddToProject(getdata);
    PublishMessageClose(getdata);

    setResponseJSON(getdata);
    setResponseModel(true);
  };

  const ExtraAccQtyIncrementClick = ({ aIndex, data }) => {
    try {
      if (!ExtraAccCartInfoArr[aIndex]) {
        ExtraAccCartInfoArr[aIndex] = { quantity: 1 };
      } else {
        let newCount = ExtraAccCartCount + 1;
        setExtraAccCartCount(newCount);
        ExtraAccCartInfoArr[aIndex] = {
          ...ExtraAccCartInfoArr[aIndex],
          quantity: ExtraAccCartInfoArr[aIndex].quantity + 1,
        };
      }

      setExtraAccCartInfoArr([...ExtraAccCartInfoArr]);
    } catch (err) {
      console.log(`Error at extra accessories increment: ${err.message} `);
    }
  };

  const ExtraAccQtyDecrClick = ({ aIndex, data }) => {
    try {
      if (ExtraAccCartInfoArr[aIndex].quantity <= 1) {
        delete ExtraAccCartInfoArr[aIndex];
      } else {
        ExtraAccCartInfoArr[aIndex] = {
          ...ExtraAccCartInfoArr[aIndex],
          quantity: ExtraAccCartInfoArr[aIndex].quantity - 1,
        };
      }

      setExtraAccCartCount(ExtraAccCartCount - 1);
      setExtraAccCartInfoArr([...ExtraAccCartInfoArr]);
    } catch (err) {
      console.log(`Error at extra accessories desc: ${err.message} `);
    }
  };

  const ExtraAccItemDeleteClick = (index) => {
    try {
      // ExtraAccCatCartList.splice(`${AccCatalogNo}|${sectionIdx}:${itemIdx}`);
      ExtraAccCatCartList.splice(index, 1);
      setExtraAccCatCartList([...ExtraAccCatCartList]);
      ExtraAccList.splice(index, 1);
      setExtraAccList([...ExtraAccList]);

      ExtraAccCartInfoArr.splice(index, 1);
      let newCount = ExtraAccCartInfoArr.reduce((c, i) => c + i.quantity, 0);
      setExtraAccCartCount(newCount);
      updateBranchBrkCartInfoArr([...ExtraAccCartInfoArr]);
    } catch (err) {
      console.log(`Error at extra accessories remove: ${err.message} `);
    }
  };

  
 return (
    <div className="product-item-list">
      <div className="main-title">
        <h4>{param === "qacomponent" ? translateFun("MySolutions") : translateFun("CatelogDetails")}</h4>
      </div>
      {Parts.length || Accessories.length || ExtraAccCartInfoArr.length ? (
        <div className="drawer-wrap">
          <div className="accordion-box">
            <ListAccordian
              Title={translateFun("Parts")}
              ListData={Parts}
              Count={Parts.length}
              AccordionKey={"PartsSection"}
              IsExpanded={PartsListExpanded}
              setExpanded={setPartsListExpanded}
              productForImageModal={productForImageModal}
              setProductForImageModal={setProductForImageModal}
              setImageModalLoader={setImageModalLoader}
              param={param}
              handleOpen={handleOpen}
              handleClose={handleClose}
              // mui Icons
              ExpandMoreIcon={ExpandMoreIcon}
              AddIcon={AddIcon}
              AddCircleIcon={AddCircleIcon}
              ArrowRightIcon={ArrowRightIcon}
              RemoveCircleIcon={RemoveCircleIcon}
              CancelIcon={CancelIcon}
              InfoRoundedIcon={InfoRoundedIcon}
              // mui components
              Accordion={Accordion}
              AccordionSummary={AccordionSummary}
              Typography={Typography}
              List={List}
              ListItem={ListItem}
              ListItemAvatar={ListItemAvatar}
              Avatar={Avatar}
              ListItemText={ListItemText}
              Tooltip={Tooltip}
              Button={Button}
            // setImageUrl={setImageUrl}
            // setproductNo={setproductNo}
            />

            {((productNumber == 'ASCO1') || (productNumber == 'ASCO2')) ? (
              <ListAccordianASCO
              Title={translateFun("Accessories")}
              ListData={Accessories}
              Count={AccessoriesCartCount}
              IsAddAction={true}
              AccAddBtnClick={ASCOAccAddBtnClick}
              AccQtyDecrClick={AccQtyDecrClick}
              intialPartsarray={AccCartQtyInfoArr}
              AccordionKey={"AccessoriesSection"}
              IsExpanded={AccListExpanded}
              setExpanded={setAccListExpanded}
              productForImageModal={productForImageModal}
              setProductForImageModal={setProductForImageModal}
              setImageModalLoader={setImageModalLoader}
              DisplayResultCount={true}
              param={param}
              handleOpen={handleOpen}
              handleClose={handleClose}
              // mui components
              Accordion={Accordion}
              AccordionSummary={AccordionSummary}
              Typography={Typography}
              List={List}
              ListItem={ListItem}
              ListItemAvatar={ListItemAvatar}
              Avatar={Avatar}
              ListItemText={ListItemText}
              Tooltip={Tooltip}
              Button={Button}
              // mui Icons
              ExpandMoreIcon={ExpandMoreIcon}
              AddIcon={AddIcon}
              RemoveCircleIcon={RemoveCircleIcon}
              CancelIcon={CancelIcon}
              InfoRoundedIcon={InfoRoundedIcon}
              disbAccArr={disbAccArr}
              AccAddMandatory={AccAddMandatory}
              mandSelAccArr={mandSelAccArr}
            />
            ) : (
              <ListAccordian
              Title={translateFun("Accessories")}
              ListData={Accessories}
              Count={AccessoriesCartCount}
              IsAddAction={true}
              AccAddBtnClick={AccAddBtnClick}
              AccQtyIncrementClick={AccQtyIncrementClick}
              AccQtyDecrClick={AccQtyDecrClick}
              intialPartsarray={AccCartQtyInfoArr}
              AccordionKey={"AccessoriesSection"}
              IsExpanded={AccListExpanded}
              setExpanded={setAccListExpanded}
              productForImageModal={productForImageModal}
              setProductForImageModal={setProductForImageModal}
              setImageModalLoader={setImageModalLoader}
              DisplayResultCount={true}
              param={param}
              handleOpen={handleOpen}
              handleClose={handleClose}
              // mui components
              Accordion={Accordion}
              AccordionSummary={AccordionSummary}
              Typography={Typography}
              List={List}
              ListItem={ListItem}
              ListItemAvatar={ListItemAvatar}
              Avatar={Avatar}
              ListItemText={ListItemText}
              Tooltip={Tooltip}
              Button={Button}
              // mui Icons
              ExpandMoreIcon={ExpandMoreIcon}
              AddIcon={AddIcon}
              AddCircleIcon={AddCircleIcon}
              ArrowRightIcon={ArrowRightIcon}
              RemoveCircleIcon={RemoveCircleIcon}
              CancelIcon={CancelIcon}
              InfoRoundedIcon={InfoRoundedIcon}
            // setImageUrl={setImageUrl}
            // setproductNo={setproductNo}
            />
            )}

            {MainBreakersList.length ? (
              <ListAccordian
                Title={translateFun("MainBreaker")}
                ListData={MainBreakersList}
                Count={MainBreakersList.length}
                AccordionKey={"MainBreakerSection"}
                IsDeleteItemAction={true}
                ItemDeleteClick={MainBreakerDeleteClick}
                IsExpanded={MainBrkListExpanded}
                setExpanded={setMainBrkListExpanded}
                productForImageModal={productForImageModal}
                setProductForImageModal={setProductForImageModal}
                setImageModalLoader={setImageModalLoader}
                param={param}
                handleOpen={handleOpen}
                handleClose={handleClose}
                // mui components
                Accordion={Accordion}
                AccordionSummary={AccordionSummary}
                Typography={Typography}
                List={List}
                ListItem={ListItem}
                ListItemAvatar={ListItemAvatar}
                Avatar={Avatar}
                ListItemText={ListItemText}
                Tooltip={Tooltip}
                Button={Button}
                // mui Icons
                ExpandMoreIcon={ExpandMoreIcon}
                AddIcon={AddIcon}
                AddCircleIcon={AddCircleIcon}
                ArrowRightIcon={ArrowRightIcon}
                RemoveCircleIcon={RemoveCircleIcon}
                CancelIcon={CancelIcon}
                InfoRoundedIcon={InfoRoundedIcon}
              // setImageUrl={setImageUrl}
              // setproductNo={setproductNo}
              />
            ) : (
              ""
            )}

            {BranchBreakersList.length ? (
              <ListAccordian
                Title={translateFun("BranchBreaker")}
                ListData={BranchBreakersList}
                Count={BranchBreakerCartCnt}
                AccordionKey={"BranchBreakerSection"}
                IsAddAction={true}
                AccAddBtnClick={BranchBrkAddBtnClick}
                AccQtyIncrementClick={BranchBrkQtyIncrementClick}
                AccQtyDecrClick={BranchBrkQtyDecrClick}
                intialPartsarray={BranchBrkCartInfoArr}
                IsDeleteItemAction={true}
                ItemDeleteClick={BranchBreakerDeleteClick}
                IsExpanded={BranchBrkListExpanded}
                setExpanded={setBranchBrkListExpanded}
                productForImageModal={productForImageModal}
                setProductForImageModal={setProductForImageModal}
                setImageModalLoader={setImageModalLoader}
                DisplayResultCount={true}
                param={param}
                handleOpen={handleOpen}
                handleClose={handleClose}
                // mui components
                Accordion={Accordion}
                AccordionSummary={AccordionSummary}
                Typography={Typography}
                List={List}
                ListItem={ListItem}
                ListItemAvatar={ListItemAvatar}
                Avatar={Avatar}
                ListItemText={ListItemText}
                Tooltip={Tooltip}
                Button={Button}
                // mui Icons
                ExpandMoreIcon={ExpandMoreIcon}
                AddIcon={AddIcon}
                AddCircleIcon={AddCircleIcon}
                ArrowRightIcon={ArrowRightIcon}
                RemoveCircleIcon={RemoveCircleIcon}
                CancelIcon={CancelIcon}
                InfoRoundedIcon={InfoRoundedIcon}
                maxCapacity={maxCapacity}
                totalSumNumber={BranchBreakerCartCnt}
              // setImageUrl={setImageUrl}
              // setproductNo={setproductNo}
              />
            ) : null}
            {ExtraAccCartInfoArr.length ? (
              <ListAccordian
                Title={translateFun("MoreAccessories")}
                ListData={ExtraAccCartInfoArr}
                Count={ExtraAccCartCount}
                IsAddAction={true}
                MinQuantity={1}
                AccQtyIncrementClick={ExtraAccQtyIncrementClick}
                AccQtyDecrClick={ExtraAccQtyDecrClick}
                IsDeleteItemAction={true}
                ItemDeleteClick={ExtraAccItemDeleteClick}
                intialPartsarray={ExtraAccCartInfoArr}
                AccordionKey={"ExtraAccessoriesSection"}
                IsExpanded={ExtraAccListExpanded}
                setExpanded={setExtraAccListExpanded}
                productForImageModal={productForImageModal}
                setProductForImageModal={setProductForImageModal}
                setImageModalLoader={setImageModalLoader}
                // DisplayResultCount={true}
                param={param}
                handleOpen={handleOpen}
                handleClose={handleClose}
                // mui components
                Accordion={Accordion}
                AccordionSummary={AccordionSummary}
                Typography={Typography}
                List={List}
                ListItem={ListItem}
                ListItemAvatar={ListItemAvatar}
                Avatar={Avatar}
                ListItemText={ListItemText}
                Tooltip={Tooltip}
                Button={Button}
                // mui Icons
                ExpandMoreIcon={ExpandMoreIcon}
                AddIcon={AddIcon}
                AddCircleIcon={AddCircleIcon}
                ArrowRightIcon={ArrowRightIcon}
                RemoveCircleIcon={RemoveCircleIcon}
                CancelIcon={CancelIcon}
                InfoRoundedIcon={InfoRoundedIcon}
              // setImageUrl={setImageUrl}
              // setproductNo={setproductNo}
              />
            ) : (
              ""
            )}
            {param == "qacomponent" ? (
              <ImageModal
                {...props}
                PartId={PartId}
                handleOpen={handleOpen}
                open={openImageModal}
                handleClose={handleClose}
              // imageUrl={imageUrl}
              // productNo={productNo}
              />
            ) : (
              ""
            )}
          </div>

          <div className="btn-wrap">
            <Button
              variant="contained"
              color="success"
              onClick={AddToCartClick}
              disabled={
                !Parts.length ||
                  (BreakerQueList.length && !MainBreakersList.length)
                  ? true
                  : false
              }
            >
              {translateFun("AddToCart")}
            </Button>
          </div>

          {/* <Dialog
            open={ResponseModel}
            onClose={() => setResponseModel(false)}
            maxWidth={"lg"}
          >
            <DialogTitle style={{ backgroundColor: "#3dcd58" }}>
              <b>Response</b>
            </DialogTitle>
            <DialogContent style={{ fontSize: 14, padding: 10 }}>
              <p>{JSON.stringify(ResponseJSON, undefined, 2)}</p>
            </DialogContent>
          </Dialog> */}
        </div>
      ) : (
        <div className="empty-list-content">
          <div className="main-content">
            <div className="main-info">
              <div className="img-box">
                <img
                  src={process.env.PUBLIC_URL + "/asset/images/list-icon.png"}
                  alt=""
                  className="img-fluid"
                />
              </div>
              <p>
                {translateFun("YourConfigurationNotCompleted")}
              </p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
